import { ButtonV2 } from '@findy-code/yuffie/ui/button';
import { VisualModal } from '@findy-code/yuffie/ui/modal';
import { VisuallyHidden } from '@findy-code/yuffie/ui/visually-hidden';
import { FaExternalLinkAlt } from 'react-icons/fa';

import MainImage from './images/user-success-modal.png';
import styles from './user-success-modal.component.module.scss';

type Props = {
  isOpen?: boolean;

  /**
   * us-lpのURLに付与するGA計測用のパラメーター
   * utm_sourceはfindy-code, utm_mediumはsiteで固定
   */
  utmCampaign?: string;

  onAfterOpen?: () => void;
  onClose?: () => void;
};

export const UserSuccessModalComponent = ({
  isOpen,
  utmCampaign,
  onAfterOpen,
  onClose,
}: Props) => {
  const params = new URLSearchParams({
    utm_source: 'findy-code',
    utm_medium: 'site',
  });

  if (typeof utmCampaign === 'string') {
    params.append('utm_campaign', utmCampaign);
  }

  return (
    <VisualModal
      alt="市場動向やトレンドがわかるユーザーサクセス面談。面談後満足度※1 96.2%、面談実施数8,500件※2"
      aria={{ labelledby: 'user-success-modal' }}
      body={
        <div className={styles.userSuccessModalContent}>
          <VisuallyHidden as="p">
            ※1:2024年1月〜2025年1月に実施した面談アンケートにて5段階評価で&quot;満足&quot;もしくは&quot;非常に満足&quot;と回答頂いた方の割合
            <br />
            ※2:2019年1月〜2025年1月までに面談に参加頂いたユーザーの累計数
          </VisuallyHidden>

          <p>
            Findyならではのエンジニア・企業両面からの豊富な情報をお伝えします。
            <br />
            転職活動中の方はもちろん、情報収集目的の方も気軽にご参加ください！
          </p>

          <div>
            <ButtonV2
              as="a"
              endIcon={FaExternalLinkAlt}
              href={`/us-lp?${params.toString()}`}
              rel="noopener"
              target="_blank"
            >
              ユーザーサクセス面談に申し込む
            </ButtonV2>
          </div>
        </div>
      }
      isOpen={isOpen}
      src={MainImage}
      title="ユーザーサクセス面談のご案内"
      onAfterOpen={onAfterOpen}
      onRequestClose={onClose}
    />
  );
};
